import React, { FC } from "react";
import { Grid, Link, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useHistory } from "react-router-dom";

interface Props {
  modalOpen: boolean;
  setModalOpen: any;
}

const CreateFirstTemplateModal: FC<Props> = (props: Props) => {
  const history = useHistory();

  const handleOptionSelection = () => {
    history.push("/claim-template-builder");
  };

  return (
    <Modal open={props.modalOpen} className="follow-up-modal">
      <div className="paper" style={{ width: "475px", padding: "0px" }}>
        <div className="paperInner" style={{ padding: "0px" }}>
          <Grid container className="fum-header-container">
            <Grid item xs={10}>
              <h1 className="fum-header">Create your First Template!</h1>
            </Grid>
            <Grid
              item
              xs={2}
              className="fum-close-icon-container"
              style={{ paddingRight: "20px" }}
            >
              <Link
                onClick={() => props.setModalOpen(false)}
                style={{ color: "black" }}
              >
                <CloseIcon />
              </Link>
            </Grid>
          </Grid>
          <div className="divider-orange" style={{ margin: "0px" }}></div>

          <Grid item xs={12} style={{ padding: "25px" }}>
            It looks like you don’t have any templates yet. Head over to the
            Claim Template Builder to create your first template!
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            style={{ padding: "30px" }}
          >
            <Grid
              item
              xs={4}
              className="cancel-link-container"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Link
                className="cancel-link"
                onClick={() => props.setModalOpen(false)}
              >
                Cancel
              </Link>
            </Grid>
            <Grid item xs={8} className="confirm-btn-container">
              <Link
                onClick={handleOptionSelection}
                className="confirm-btn"
                style={{ width: "220px" }}
              >
                Go to Claim Template Builder
              </Link>
            </Grid>
          </Grid>
        </div>
      </div>
    </Modal>
  );
};

export default CreateFirstTemplateModal;
